/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Anchor_Clear_TitleInputs */

const en_us2_body_assessment_anchor_clear_title = /** @type {(inputs: Body_Assessment_Anchor_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop using the reference?`)
};

const pt_br2_body_assessment_anchor_clear_title = /** @type {(inputs: Body_Assessment_Anchor_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar de usar a referência?`)
};

const es_419_body_assessment_anchor_clear_title = /** @type {(inputs: Body_Assessment_Anchor_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dejar de usar la referencia?`)
};

const pt_pt2_body_assessment_anchor_clear_title = /** @type {(inputs: Body_Assessment_Anchor_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar de usar a referência?`)
};

const fr_fr2_body_assessment_anchor_clear_title = /** @type {(inputs: Body_Assessment_Anchor_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus utiliser la référence ?`)
};

const de_de2_body_assessment_anchor_clear_title = /** @type {(inputs: Body_Assessment_Anchor_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenz nicht mehr nutzen?`)
};

const it_it2_body_assessment_anchor_clear_title = /** @type {(inputs: Body_Assessment_Anchor_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smettere di usare il riferimento?`)
};

/**
* | output |
* | --- |
* | "Stop using the reference?" |
*
* @param {Body_Assessment_Anchor_Clear_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_anchor_clear_title = /** @type {((inputs?: Body_Assessment_Anchor_Clear_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Anchor_Clear_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_anchor_clear_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_anchor_clear_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_anchor_clear_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_anchor_clear_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_anchor_clear_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_anchor_clear_title(inputs)
	return en_us2_body_assessment_anchor_clear_title(inputs)
});
export { body_assessment_anchor_clear_title as "body-assessment.anchor_clear_title" }